import React from "react";

export const ArrowUp = ({ color = "#51569F" }) => {
  return (
    <svg width="22" height="21" viewBox="0 0 22 21" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g filter="url(#filter0_d_122_27489)">
        <path
          d="M9.29451 1.80618C10.0725 0.526185 11.9306 0.526184 12.7112 1.80618L17.1595 9.10096C17.9722 10.4337 17.0145 12.141 15.4542 12.141H6.57228C5.01193 12.141 4.05085 10.4337 4.86089 9.10096L9.29451 1.80618Z"
          fill={color}
        />
      </g>
      <defs>
        <filter
          id="filter0_d_122_27489"
          x="0.566895"
          y="0.846191"
          width="20.8882"
          height="19.2948"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="4" />
          <feGaussianBlur stdDeviation="2" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_122_27489" />
          <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_122_27489" result="shape" />
        </filter>
      </defs>
    </svg>
  );
};
